
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralXShape as ObiBeaconGeneralXShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-x-shape.js';
 
 
 

 
 export const ObiBeaconGeneralXShape = createComponent({
   react: React,
   tagName: 'obi-beacon-general-x-shape',
   elementClass: ObiBeaconGeneralXShapeElement,
   events: {
     
   }
  });
 
 